
import { Vue, Component, Prop } from "nuxt-property-decorator";
import { SOCIAL_PROVIDERS } from "@/domain/constants/CommunityConst";

@Component({
  name: "CommunitySocialShare",
  components: {},
})
export default class CommunitySocialShare extends Vue {
  @Prop({}) enabledProviders!: string[];
  @Prop({ default: true }) showLabels!: boolean;
  @Prop({ default: 'currentColor' }) iconColor: string;

  private url = "";
  private text = "";

  private providers = {
    [SOCIAL_PROVIDERS.TWITTER]:
      "https://twitter.com/intent/tweet/?url=:url&href=:url&text=:title",
    [SOCIAL_PROVIDERS.FACEBOOK]:
      "https://www.facebook.com/sharer/sharer.php?u=:url&title=:title",
    [SOCIAL_PROVIDERS.LINKEDIN]:
      "https://www.linkedin.com/sharing/share-offsite/?url=:url&title=:title",
  };

  private getProviderName(provider: string): string {
    switch (provider) {
      case "linkedin":
        return "LinkedIn";
      default:
        return provider?.charAt(0).toUpperCase() + provider?.toLowerCase().slice(1);
    }
  }

  private getShareUrl(provider: string): string {
    if (this.providers[provider]) {
      return this.providers[provider]
        .replace(":url", this.url)
        .replace(":title", this.text);
    }
    return "";
  }

  private share(provider: string): boolean {
    const url = this.getShareUrl(provider);
    if (url) {
      window.open(url, "sharer", "toolbar=0,status=0,width=648,height=395");
      return true;
    }
    return false;
  }

  private mounted() {
    this.url = window.location.href;
  }
}
